import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Table,
  TableBody,
  TableContainer,
  Checkbox,
  Link,
  Typography,
  Container,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import GetAppIcon from "@material-ui/icons/GetApp";
import HelpButton from "../component/HelpButton";

var macVer = process.env.REACT_APP_MAC_SYSTEM;
macVer = macVer.substring(macVer.indexOf("-") + 1);
macVer = macVer.substring(0, macVer.indexOf(".dmg"));
var winVer = process.env.REACT_APP_WIN_SYSTEM;
winVer = winVer.substring(winVer.indexOf("Setup%20") + 8);
winVer = winVer.substring(0, winVer.indexOf(".exe"));

const useStyles = makeStyles((theme) => ({
  interval: {
    marginTop: theme.spacing(5),
  },
}));

// ログイン画面を定義したコンポーネント
export default function Download(props) {
  const classes = useStyles();
  const [checked, setChecked] = useState();

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <React.Fragment>
      <Alert variant="outlined" severity="info">
        このページではシステムのダウンロードと画像編集に使用するフレームやエフェクトのダウンロードができます。
        <br />
        ダウンロードするには利用規約・プライバシーポリシーをよく読み「同意する」にチェックを入れてください。
      </Alert>
      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          ダウンロード
        </Typography>
        <div style={{ textAlign: "center" }}>
          <Link
            color="textSecondary"
            href="https://docs.google.com/document/d/e/2PACX-1vQfu-LAIibnvwlkFCVPdbAOhn2xYNDx_Q1IQQM6eUyHOiLzR3NzEMrkvCgbpl5zfB4ceHZsTarcl5WN/pub"
          >
            利用規約
          </Link>
          ・
          <Link
            color="textSecondary"
            href="https://docs.google.com/document/d/e/2PACX-1vSerY4sUN6UAqTzbQAYwtW9rse_1KVnnML2W1c2FedTJpaT7-VrogYQPT-SvrpS_lLS0sBRrkmUsR1C/pub"
          >
            プライバシーポリシー
          </Link>
          に同意の上、ご利用ください。
        </div>
        <div style={{ textAlign: "center" }}>
          <Checkbox
            checked={checked}
            onChange={handleChange}
            inputProps={{ "aria-label": "primary checkbox" }}
          />
          同意する
        </div>

        <TableContainer className={classes.interval}>
          <Typography variant="h4" align="center">
            システム
          </Typography>
          <Typography variant="caption" align="center" gutterBottom>
            お持ちのパソコンがMac、Windowsのどちらか該当する方を選び、「ダウンロード」を押してください。
          </Typography>

          <Table stickyHeader>
            <TableBody>
              <StyledTableRow key="Mac">
                <StyledTableCell>Macをご利用の方 →</StyledTableCell>
                <StyledTableCell>
                  <Button
                    disabled={!checked}
                    href={`${process.env.REACT_APP_MAC_SYSTEM}`}
                    variant="contained"
                    color="primary"
                    endIcon={<GetAppIcon />}
                  >
                    Ver.{macVer} をダウンロード
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow key="Windows">
                <StyledTableCell>Windowsをご利用の方 →</StyledTableCell>
                <StyledTableCell>
                  <Button
                    disabled={!checked}
                    href={`${process.env.REACT_APP_WIN_SYSTEM}`}
                    variant="contained"
                    color="primary"
                    endIcon={<GetAppIcon />}
                  >
                    Ver.{winVer} をダウンロード
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <TableContainer className={classes.interval}>
          <Typography variant="h4" align="center">
            画像素材アイテム
          </Typography>
          <Typography variant="caption" align="center" gutterBottom>
            見栄え良く画像加工をするためのアイテムをダウンロードできます。
          </Typography>

          <Table stickyHeader>
            <TableBody>
              <StyledTableRow key="frame">
                <StyledTableCell>
                  <HelpButton
                    title={
                      <>
                        <Typography variant="caption" display="block">
                          フレームの作り方
                        </Typography>
                        <Button
                          variant="contained"
                          target="_blank"
                          fullWidth
                          href="https://youtu.be/yGjjve64OYY"
                        >
                          詳しくはこちら
                        </Button>
                      </>
                    }
                  />
                  画像フレームが必要な方 →
                </StyledTableCell>
                <StyledTableCell>
                  <Button
                    disabled={!checked}
                    href={`${process.env.REACT_APP_FRAME}`}
                    variant="contained"
                    color="primary"
                    endIcon={<GetAppIcon />}
                  >
                    ダウンロード
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow key="effect">
                <StyledTableCell>
                  <HelpButton
                    title={
                      <>
                        <Typography variant="caption" display="block">
                          エフェクトについて
                        </Typography>
                        <Button
                          variant="contained"
                          target="_blank"
                          fullWidth
                          href="https://youtu.be/N3YECq8i_2g"
                        >
                          詳しくはこちら
                        </Button>
                      </>
                    }
                  />
                  画像エフェクトが必要な方 →
                </StyledTableCell>
                <StyledTableCell>
                  <Button
                    disabled={!checked}
                    href={`${process.env.REACT_APP_EFFECT}`}
                    variant="contained"
                    color="primary"
                    endIcon={<GetAppIcon />}
                  >
                    ダウンロード
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </React.Fragment>
  );
}
